import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=d2682708&scoped=true&"
import script from "./ContactList.vue?vue&type=script&lang=js&"
export * from "./ContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2682708",
  null
  
)

export default component.exports